// @flow

import * as React from 'react';

import s from './Calendar.scss';

type Props = {
  label: string|number,
  value: string|number,
  name: string|number,
  onChange: (e: SyntheticEvent<any>) => void,
  disabled: boolean,
}

export const Calendar = (props: Props) => {
  const { label, value, name, onChange, disabled, ...otherprops } = props;

  return (
    <input
      type="date"
      className={s.calendar}
      label={label}
      name={name}
      value={value}
      onChange={(e) => onChange(e)}
      disabled={disabled}
      {...otherprops}
    />
  )
}



export default Calendar;